module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-laptop-c56b6c4c0a7f14d167a5ac827f1b7087.png";